export enum ProductDetail {
  ProductName = 'productDetails-productName',
  SerialNumber = 'productDetails-serialNumber',
  ModelNumber = 'productDetails-modelNumber',
}
